import { ReactNode } from 'react';

export enum ROUTES {
  HOME = '/',
  SIGN_IN = '/sign-in',
  RESET_PASSWORD = '/reset-password',
  SIGN_UP = '/sign-up',
  ABOUT_US = '/about-us',
  ADMINS = '/admins',
  USERS = '/users',
  SETTINGS = '/settings',
  REQUIRED_DOCUMENTS = '/settings/documents/:propertyType/:source',
  PROPERTIES = '/properties-in-progress',
  PROPERTIES_SOLD = '/properties-sold',
  ORDERS = '/orders',
  PROFILE = '/profile',
  NOT_FOUND = '*',
}

export interface IRouteConfig {
  title: string;
  path: ROUTES;
  component: ReactNode;
  icon?: Element;
}
